import { defineStore } from "pinia";
import { api } from "@/shared/resource/apis/baseApi";

import { REFFERAL } from "@/shared/resource/apis/endpoints";
import { dateTime } from "@/shared/utills/date";
import {
  REFFERAL_INFORMATION,
  REFEREE_INFORMATION,
} from "@/shared/resource/constants";

export const useRefferalStore = defineStore("refferal", {
  state: () => ({
    entities: [],
    totalEntities: 0,
    information: [...REFFERAL_INFORMATION],
    refereeInformation: [...REFEREE_INFORMATION],
  }),

  actions: {
    clearEntities() {
      this.entities = [];
      this.totalEntities = 0;
    },

    async fetch({ page = 1, limit = 10, filters = {} }) {
      this.clearEntities();

      const response = await api.get(REFFERAL.GET, {
        params: { page_no: page, limit, ...filters },
      });
      const data = response?.data?.data || [];

      const formattedEntities = data.map((refferal) => ({
        uuid: refferal.id,
        id: refferal.referral_code,
        type: refferal.user_type || "-",
        totalRefferals: refferal.total_referrals,
        successfullRefferals: refferal.success_referrals,
        rewardsEarned: refferal.reward_earned,
        walletBalance: refferal.wallet_balance || "0",
        createdAt:  dateTime.formatDateTime(refferal.created_at),
        status: refferal.is_active,
      }));

      this.setEntities(formattedEntities, response.data.total_count || 0);
      this.setInformation(response.data);
      return formattedEntities;
    },

    setEntities(entities, totalEntities) {
      this.entities = entities;
      this.totalEntities = totalEntities;
    },

    setInformation(value) {
      this.information[0].count = value.success_count || 0;
      this.information[1].count = value.total_amount_settled || 0;
      this.information[2].count = value.total_reward_earned || 0;
    },

    setRefreeInformation(value) {
      const {
        total_referrals,
        success_referrals,
        dormant_referrals,
        rewardEarned,
        total_revenue,
      } = value || {};

      this.refereeInformation[0].value = total_referrals || 0;
      this.refereeInformation[1].value = success_referrals || 0;
      this.refereeInformation[2].value = `₹ ${rewardEarned || 0}`;
      this.refereeInformation[3].value = dormant_referrals || 0;
      this.refereeInformation[4].value = `₹ ${total_revenue || 0}`;
    },

    async getReferralByCode(refferrerCode) {
      if (!refferrerCode) return;

      const response = await api.get(REFFERAL.GET_BY_ID(refferrerCode));
      if (response?.data?.success) {
        this.setRefreeInformation(response?.data?.data || {});
        return response?.data || {};
      }
    },
  },
  getters: {
    getEntities: (state) => state.entities,
    getInformation: (state) => state.information,
    getRefereeInformation: (state) => state.refereeInformation,
    getTotalEntities: (state) => state.totalEntities,
  },
});
